module.exports = __webpack_public_path__ + "static/media/edit.f4398d11.svg";